import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import {
  TopicReleasePolicy,
  UpsertTopicReleasePolicyDto,
} from "./TopicReleasePolicy.model";

export function useTopicReleasePolicyApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      upsertTopicReleasePolicy: async (input: UpsertTopicReleasePolicyDto) =>
        apiResolver<TopicReleasePolicy>(
          api.post("/platform/topic-release-policies", input)
        ),
      updateTopicReleasePolicy: async (
        topicId: number,
        releaseId: number,
        input: UpsertTopicReleasePolicyDto
      ) =>
        apiResolver<TopicReleasePolicy>(
          api.put(
            `/platform/topic-release-policies/${topicId}/${releaseId}`,
            input
          )
        ),
      deleteTopicReleasePolicy: async (topicId: number, releaseId: number) =>
        apiResolver<{ success: boolean }>(
          api.delete(`/platform/topic-release-policies/${topicId}/${releaseId}`)
        ),
      deactivateTopicReleasePolicy: async (
        topicId: number,
        releaseId: number
      ) =>
        apiResolver<TopicReleasePolicy>(
          api.put(
            `/platform/topic-release-policies/${topicId}/${releaseId}/deactivate`
          )
        ),
      getTopicReleasePolicies: async (releaseId?: number, topicId?: number) => {
        const params = new URLSearchParams();
        if (releaseId) params.append("releaseId", releaseId.toString());
        if (topicId) params.append("topicId", topicId.toString());

        return apiResolver<TopicReleasePolicy[]>(
          api.get(
            `/platform/topic-release-policies${
              params.toString() ? `?${params.toString()}` : ""
            }`
          )
        );
      },
      getTopicReleasePolicy: async (topicId: number, releaseId: number) =>
        apiResolver<TopicReleasePolicy | null>(
          api.get(`/platform/topic-release-policies/${topicId}/${releaseId}`)
        ),
    }),
    [api]
  );
}
